import { Decoder, tools, Reader } from 'ts-ebml';
// This array comes from the ts-ebml code:
// https://github.com/legokichi/ts-ebml/blob/master/src/EBML.ts
const validEmlTypes = ['m', 'u', 'i', 'f', 's', '8', 'b', 'd'];

const readAsArrayBuffer = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsArrayBuffer(blob);
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.onerror = (ev) => {
      reject(ev.error);
    };
  });
};

export const injectMetadata = async (blob) => {
  const decoder = new Decoder();
  const reader = new Reader();
  reader.logging = false;
  reader.drop_default_duration = false;

  return readAsArrayBuffer(blob).then((buffer) => {
    // CT-2277: Fix suggested on the ts-ebml repository
    // https://github.com/legokichi/ts-ebml/issues/33
    const elms = decoder.decode(buffer);
    elms.filter((elm) => validEmlTypes.includes(elm.type)).forEach((elm) => reader.read(elm));
    reader.stop();

    const refinedMetadataBuf = tools.makeMetadataSeekable(reader.metadatas, reader.duration, reader.cues);
    const body = buffer.slice(reader.metadataSize);

    const result = new Blob([refinedMetadataBuf, body], {
      type: blob.type,
    });

    return result;
  });
};
